<div class="ccr-container">
    <!-- Add Row Button -->
    <div class="add-button">
        <ham-button outline="true" [size]="'xs'" icon="assets/hamIcons/plus-outline.svg" (buttonClick)="addRow()">
            {{ 'aumico_annual_report_proposal_add_new_item' | i18next }}
        </ham-button>
    </div>

    <!-- CCR Table -->
    <div class="ccr-table-wrapper" *ngIf="form">
        <form [formGroup]="form">
            <table class="custom-table">
                <!-- Header row -->
                <thead>
                    <tr>
                        <th class="aumText aumOverflowEdit">
                            <ham-inline-table-cell-edit
                                [value]="ccrDescription"
                                (save)="onSaveCcrDescription($event)"
                            ></ham-inline-table-cell-edit>
                        </th>
                        <th class="aumHighlight">
                            <span>{{ currentYearDate | dateLocale }}</span>
                        </th>
                        <th>
                            <span>{{ previousYearDate | dateLocale }}</span>
                        </th>
                        <th></th>
                    </tr>
                </thead>

                <tbody formArrayName="entries">
                    <!-- ── Opening balance row ───────────────────────────────── -->
                    <tr class="system-row">
                        <td class="aumText aumTextCell">
                            <ham-inline-table-cell-edit
                                [value]="totalBeginningText"
                                (save)="onSaveTotalBeginningText($event)"
                            ></ham-inline-table-cell-edit>
                            <div class="dropdown-container">
                                <input
                                    hamSimpleDropDown
                                    [options]="equityAccountsForDropdown"
                                    [optionKeys]="['displayLabel']"
                                    returnKey="accountNumber"
                                    [returnObject]="true"
                                    [placeholder]="'aumico_annual_report_ccr_select_account' | i18next"
                                    [multiple]="true"
                                    [formControl]="equityAccountControl"
                                />
                            </div>
                        </td>
                        <td class="aumHighlight aumTextCell">
                            <aum-form-field-label>
                                {{ openingCur != null ? (openingCur | finNumber : numberFormat) : '' }}
                            </aum-form-field-label>
                        </td>
                        <td class="aumTextCell">
                            <aum-form-field-label *ngIf="openingPrev != null; else openingPrevInput">
                                {{ openingPrev | finNumber : numberFormat }}
                            </aum-form-field-label>
                            <ng-template #openingPrevInput>
                                <input
                                    hamInput
                                    type="number"
                                    class="number-input"
                                    [formControl]="openingPrevControl"
                                    [placeholder]="'aumico_annual_report_ccr_enter_value' | i18next"
                                />
                            </ng-template>
                        </td>
                        <td class="lock-col">
                            <span class="ham-icon lock-icon"><i class="lock-icon"></i></span>
                        </td>
                    </tr>

                    <!-- ── Dynamic entry rows ───────────────────────────────── -->
                    <ng-container *ngFor="let entryCtrl of entriesArray.controls; let i = index">
                        <tr [formGroupName]="i" class="entry-row">
                            <!-- Name column -->
                            <td class="aumText aumTextCell">
                                <ng-container *ngIf="isLabelLocked(entriesData[i]); else editableName">
                                    <span class="locked-label">{{ getEntryControl('name', i).value }}</span>
                                </ng-container>
                                <ng-template #editableName>
                                    <input
                                        hamInput
                                        formControlName="name"
                                        [placeholder]="'aumico_annual_report_ccr_enter_text' | i18next"
                                    />
                                </ng-template>
                            </td>

                            <!-- Current value -->
                            <td
                                class="aumHighlight aumTextCell"
                                [ngClass]="{ todoHighlight: !getEntryControl('currentValue', i).value }"
                            >
                                <input
                                    hamInput
                                    type="number"
                                    class="number-input"
                                    formControlName="currentValue"
                                    [placeholder]="'aumico_annual_report_ccr_enter_value' | i18next"
                                />
                            </td>

                            <!-- Previous value -->
                            <td
                                class="aumTextCell"
                                [ngClass]="{
                                    todoHighlight:
                                        !getEntryControl('previousValue', i).value && !isLabelLocked(entriesData[i])
                                }"
                            >
                                <ng-container *ngIf="isLabelLocked(entriesData[i]); else editablePrev">
                                    <aum-form-field-label>
                                        {{
                                            getEntryControl('previousValue', i).value != null
                                                ? (getEntryControl('previousValue', i).value | finNumber : numberFormat)
                                                : ''
                                        }}
                                    </aum-form-field-label>
                                </ng-container>
                                <ng-template #editablePrev>
                                    <input
                                        hamInput
                                        type="number"
                                        class="number-input"
                                        formControlName="previousValue"
                                        [placeholder]="'aumico_annual_report_ccr_enter_value' | i18next"
                                    />
                                </ng-template>
                            </td>

                            <!-- Delete button -->
                            <td class="action-col">
                                <span *ngIf="!isDeleteDisabled(entriesData[i])" class="ham-icon" (click)="removeAt(i)">
                                    <i class="grey-remove-icon"></i>
                                </span>
                            </td>
                        </tr>
                    </ng-container>

                    <!-- ── Closing balance row ───────────────────────────────── -->
                    <tr class="system-row">
                        <td class="aumText aumTextCell">
                            <ham-inline-table-cell-edit
                                [value]="totalEndText"
                                (save)="onSaveTotalEndText($event)"
                            ></ham-inline-table-cell-edit>
                        </td>
                        <td class="aumHighlight aumTextCell">
                            <aum-form-field-label>
                                {{ closingCur != null ? (closingCur | finNumber : numberFormat) : '' }}
                            </aum-form-field-label>
                        </td>
                        <td class="aumTextCell">
                            <aum-form-field-label *ngIf="closingPrev != null; else closingPrevInput">
                                {{ closingPrev | finNumber : numberFormat }}
                            </aum-form-field-label>
                            <ng-template #closingPrevInput>
                                <input
                                    hamInput
                                    type="number"
                                    class="number-input"
                                    [formControl]="closingPrevControl"
                                    [placeholder]="'aumico_annual_report_ccr_enter_value' | i18next"
                                />
                            </ng-template>
                        </td>
                        <td class="lock-col">
                            <span class="ham-icon lock-icon"><i class="lock-icon"></i></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>

        <!-- Mismatch warnings -->
        <div *ngIf="priorYearDiff != null" class="diff-warning diff-prior">
            {{ 'aumico_annual_report_ccr_diff_prior' | i18next }}: {{ priorYearDiff | finNumber : numberFormat }}
        </div>
        <div *ngIf="currentYearDiff != null" class="diff-warning diff-cur">
            {{ 'aumico_annual_report_ccr_diff_cur' | i18next }}: {{ currentYearDiff | finNumber : numberFormat }}
        </div>

        <!-- Footnote row -->
        <div class="footnote-row">
            <span
                hamCheckbox
                [formControl]="footnoteCheckboxControl"
                (change)="onFootnoteCheckboxChange($event.checked)"
            >
                {{ 'aumico_annual_report_ccr_add_comment' | i18next }}
            </span>

            <div *ngIf="showFootnote" class="footnote-editor">
                <ham-tiptap-toolbar [editor]="tiptapEditor">
                    <div #ccrFootnoteHost class="tiptap-editor"></div>
                </ham-tiptap-toolbar>
            </div>
        </div>
    </div>
</div>

<!-- Confirm remove footnote modal -->
<ham-confirm-decline-modal
    *ngIf="showRemoveFootnoteConfirm"
    (cancel)="cancelRemoveFootnote()"
    (action)="confirmRemoveFootnote()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_annual_report_cancel_button' | i18next }}"
>
    <div class="flex-center">
        <span class="ham-icon exclamation-wrapper">
            <i class="exclamation-outline-icon"></i>
        </span>
        <span class="workflow-text1">
            {{ 'aumico_annual_report_ccr_remove_comment_confirm' | i18next }}
        </span>
    </div>
</ham-confirm-decline-modal>
